import { NetworkType } from '@layerswap/widget-types';
import resolveChain from "./evmUtils/resolveChain";
import { createPublicClient } from "viem";
import { resolveFallbackTransport } from "./evmUtils/resolveTransports";
export class EVMContractAddressProvider {
    supportsNetwork(network) {
        return network.type === NetworkType.EVM;
    }
    async isContractAddress(address, network) {
        if (!network || !address) {
            return false;
        }
        try {
            const chain = resolveChain(network);
            const publicClient = createPublicClient({
                chain,
                transport: resolveFallbackTransport(network.nodes)
            });
            const bytecode = await publicClient.getCode({
                address: address
            });
            if (bytecode && bytecode !== '0x' && !bytecode.startsWith('0xef0100')) {
                return true;
            }
            else {
                return false;
            }
        }
        catch {
            return false;
        }
    }
}
